import { Icon, Tab, Tabs, useTheme } from "@mui/material";
import React from "react";
import { StandardText } from "./../../../../../globalComponents/standard";
//import { DEFAULT_THEME } from "../../../../../../colors";

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
      style={{ padding: 0, margin: 5 }}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

const tabs = [
  { title: "Carteira", icon: "wallet" },
  { title: "Movimentações", icon: "swap_vert" },
  { title: "Resgatar Prêmios", icon: "redeem" },
];

const ViewTabs = ({ children }) => {
  const [tabValue, setTabValue] = React.useState(0);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const theme = useTheme();

  return (
    <React.Fragment>
      <Tabs
        value={tabValue}
        onChange={handleChangeTab}
        variant="scrollable"
        indicatorColor="primary"
        textColor="primary"
        aria-label="scrollable force tabs example"
        style={{
          paddingLeft: 0,
          marginLeft: 0,
          paddingRight: 0,
          background: theme.palette.secondary.dark,
          minWidth: "100vw",
        }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={
              <StandardText
                color="inherit"
                startIcon={<Icon fontSize="small">{tab.icon}</Icon>}
                size={14}
              >
                {tab.title}
              </StandardText>
            }
            {...a11yProps(index)}
          />
        ))}
      </Tabs>
      {children({ tabValue, TabPanel })}
    </React.Fragment>
  );
};

export default ViewTabs;
